import { updateExternalCalendarEvent as _updateExternalCalendarEvent } from '@griply/services';
import {
  CalendarEventWriteResult,
  UpdateCalendarEventInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';
import { reportUnknownCalendarEventError } from './helpers/report-unknown-calendar-event-error';

export const updateExternalCalendarEvent = async (
  payload: UpdateCalendarEventInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _updateExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    reportUnknownCalendarEventError(error, 'external-calendars-update-event');
    throw error;
  }
};
